export function hoursToDisplayFormat(hour: number) {
  return hour.toString().padStart(2, '0');
}
